import React from 'react'
import { Modal } from '@zambezi/sdk/modal'
import classNames from 'classnames'
import style from './CancelAccessModal.module.css'
import modalStyle from '@apiEnabler/ob-common/lib/view/modal.module.css'
import { getClientName } from '@apiEnabler/ob-common/lib/tpps'

export default function CancelAccessModal({
  consent,
  open,
  onCancel,
  onConfirm,
}) {
  return (
    <Modal
      className={`${modalStyle.modal} js-modal`}
      title="Stop sharing"
      withBackdrop
      withPadding
      open={open}
      onConfirm={onConfirm}
      onCancel={onCancel}
      renderFooter={(onConfirm, onCancel) => (
        <div
          className={classNames(
            'zb-modal-card-foot-actions',
            style.modalFooter
          )}
        >
          <button
            className="js-confirm-action zb-button zb-button-primary zb-modal-action"
            onClick={onConfirm}
          >
            Stop sharing
          </button>
          <button
            className="zb-button-link zb-modal-action js-cancel-action"
            onClick={onCancel}
          >
            Keep sharing
          </button>
        </div>
      )}
    >
      <div className={style.content}>
        <p className={style.subHeading}>
          You’re about to stop sharing accound information with{' '}
          {getClientName(consent)}.
        </p>
        <p>
          You should contact them to fully understand the implications of
          stopping sharing account information.
        </p>
        <p>
          If you want to re-connect, you'll have to do so on or via their app or
          website
        </p>
      </div>
    </Modal>
  )
}
